import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import { AuthService } from '../services/authentication.service';
import { history } from '../helpers/history';


export class NavMenu extends Component<any, any> {
  displayName = NavMenu.name

  constructor(props: any) {
    super(props);
  }

  logout() {
    // Clear user token and profile data from localStorage
    AuthService.logout();
    history.push('/login');
  }

  render() {
    return (
      <Navbar inverse fixedTop fluid collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to={'/'}><img src="../images/logo_jaskovo_web_4.png" /></Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to={'/'} exact>
              <NavItem>
                <Glyphicon glyph='home' /> Početna
              </NavItem>
            </LinkContainer>
            {AuthService.loggedIn() && AuthService.isAdmin() &&
              <React.Fragment>
                <LinkContainer to={'/users'}>
                  <NavItem>
                    Korisnici
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={'/mentors'}>
                  <NavItem>
                    Mentori
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={'/representatives'}>
                  <NavItem>
                    Zastupnici
                  </NavItem>
                </LinkContainer>
                <LinkContainer to={'/worktaskgroups'}>
                  <NavItem>
                    Grupe zadataka
                  </NavItem>
                </LinkContainer>
              </React.Fragment>
            }
            {!AuthService.loggedIn() &&
              <React.Fragment>
                <LinkContainer to={'/login'}>
                  <NavItem>
                    Prijava
                  </NavItem>
                </LinkContainer>
              </React.Fragment>
            }
          </Nav>
          <Nav><NavItem></NavItem></Nav>
          <Nav>
            {AuthService.loggedIn() &&
              <LinkContainer onClick={this.logout} to={'/login'}>
                <NavItem>
                  Odjavi se
                </NavItem>
              </LinkContainer>
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
